export function parseForm(data) {
  const params = new URLSearchParams(data);
  return Object.fromEntries(params.entries());
}
